import { useQuery } from '@tanstack/react-query';
import { UseQueryResult } from '@tanstack/react-query/build/modern';
import { Referral } from '@/services/referrals/referralsServicesTypes';
import { getReferrals } from '@/services/referrals/referralsService';

interface useGetReferralsResult {
  data: Referral[];
}
const useGetReferrals = (): UseQueryResult<useGetReferralsResult, Error> => {
  return useQuery<useGetReferralsResult, Error>({
    queryKey: ['referrals'],
    queryFn: getReferrals,
    refetchOnWindowFocus: true,
    staleTime: 0,
  });
};

export default useGetReferrals;
